// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gAe0","option":"styles_option__8LqF8","active":"styles_active__Z_47s"};